import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    height: 60,
    width: 960,
    maxWidth: "100%",
    backgroundColor: "white",
    paddingLeft: "20px",
    paddingRight: "20px",
    position: "fixed",
    zIndex: 999,
    top: 0,
  },
  wrapHeader: {
    display: "flex",
    padding: "15px 0",
    // justifyContent: "space-between",
    alignItems: "center",
  },
  wrapTitle: {
    // padding:"10px"
  },
  title: {
    color: "black",
  },
  wrapIcon: {
    height: "100%",
    width: "20vh",
  },
  icCart: {
    color: "black",
  },
}));

export default useStyles;
